<template>
  <div class="page-content">
    <!-- 页面标题区域 -->
    <div class="page-header d-flex d-flex-between d-flex-middle">
      <div class="page-title d-flex d-flex-middle">
        <span class="title-bar"></span>
        <span class="title-text">修改信息</span>
      </div>
      <a href="javascript:void(0)" class="back-link" @click="handlePrev"><em style="position: relative;top: -1px;">&lt;</em> 返回</a>
    </div>
    <!--  -->
    <div class="progressBox">
      <BmProgress :steps="steps" :current-step="0" />
    </div>
    <div class="contentBox">
      <HelpInfo 
        :helpId="helpId"
        @changeHelpInfo="changeHelpInfo"
        @prev-step="handlePrev" 
        @next-step="handleNext" 
      />
    </div>
  </div>
</template>

<script>
import BmProgress from "@/components/bm/bmProgress.vue";
import HelpInfo from "@/components/bm/helpInfo.vue";

export default {
  name: 'Step1SelectLocation',
  components: {
    BmProgress,
    HelpInfo
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      steps: [
        { title: '选择就读地点' },
        { title: '选择报名专业' },
        { title: '注册资料' },
        { title: '提交报名' }
      ],
      helpId: null
    }
  },
  created() {
    // 参考 xnkd-student-h5 的 editInfo.vue：加载学生信息并回显就读地点
    this.loadStudentInfo()
  },
  methods: {
    loadStudentInfo() {
      this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?target_id=22b542ab707097').then(res => {
        if (res) {
          let helpId = res.helpId || ''
          if (!helpId) {
            const helpInfoStr = localStorage.getItem('helpInfo')
            if (helpInfoStr) {
              const helpInfo = JSON.parse(helpInfoStr)
              if (helpInfo && helpInfo.id) {
                helpId = helpInfo.id
              }
            }
          }
          
          this.helpId = helpId
          if (helpId) {
            this.$http.get(this.MOCK_PREFIX + '/student/pc/getRegGroupInfo', {
              id: helpId
            }).then(helpInfo => {
              if (helpInfo) {
                localStorage.setItem('helpInfo', JSON.stringify({
                  id: helpId,
                  name: helpInfo.name || '',
                  code: helpInfo.code || '',
                  address: helpInfo.address || '',
                  principal: helpInfo.principal || '',
                  phone: helpInfo.phone || '',
                  studyMode: helpInfo.studyMode || '',
                  school: helpInfo.school || null
                }))
              }
            }).catch(err => {
              console.error('加载就读地点信息失败:', err)
            })
          }
        }
      }).catch(err => {
        console.error('获取学生信息失败:', err)
      })
    },
    handlePrev() {
      this.$router.push({ name: 'bmRegister' })
    },
    handleNext(data) {
      this.$router.push({ name: 'mineBmSelectMajor' })
    },
    changeHelpInfo(helpId){
      this.helpId = helpId
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  padding: 0 30px;
  min-height: 500px;
}

.page-header {
  height: 80px;
  line-height: 80px;
  padding: 0;
  border-bottom: 1px solid #F2F2F2;
  margin-bottom: 40px;
  .page-title {
    padding: 0;
    .title-bar {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 0 !important;
        margin-right: 10px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
  .back-link{
    font-size: 14px;
    color: #767676;
    cursor: pointer;
  }
}
</style>
